import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { MatchesModalSchema } from '@/views/sports/components/MatchesModal/styles/MatchesModal.styles';

export const matchesModalStyles: MatchesModalSchema = {
  modalWrapper: { size: 'lg', isCentered: true, scrollBehavior: 'inside' },
  modalContent: {
    color: 'gray.600',
    overflow: 'hidden',
    bg: 'alpha.300',
    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.3)',
  },
  modalHeader: {
    alignItems: 'center',
    borderBottom: '1px',
    borderColor: 'rgba(0, 0, 0, 0.25)',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
    display: 'flex',
    fontFamily: 'accent',
    fontWeight: 'medium',
    gap: '4',
    justifyContent: 'space-between',
    p: '4',
    fontSize: 'lg',
    color: 'white',
  },
  closeButton: {
    bg: 'white',
    color: 'alpha.300',
    isRound: true,
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: { bg: 'gray.800' },
  },
  divider: {
    as: 'div',
    borderColor: 'rgba(0, 0, 0, 0.25)',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  },
  modalBody: { p: '0', maxH: '400px' },
  stackWrapper: { spacing: '0' },
  linkWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    justifyContent: 'space-between',
    p: '3',
    _hover: { bg: 'alpha.400', textDecoration: 'none' },
  },
  flexSportName: {
    align: 'center',
    fontSize: 'sm',
    fontWeight: 'medium',
    fontFamily: 'accent',
    gap: '1',
    color: 'white',
  },
  iconSportName: { fontSize: '2xl', color: 'beta.300' },
  hStack: { spacing: '1' },
  countdown: {
    color: 'inherit',
    fontSize: '9px',
    h: '16px',
    py: '0',
  },
  duotoneSgmLogoOverride: {
    h: 'auto',
    w: '9',
    sx: {
      '&&': {
        svg: {
          color: 'alpha.700',
          fill: 'alpha.700',
        },
      },
    },
  },
  hStackIcon: {
    as: ChevronRight,
    color: 'white',
    fontSize: '2xl',
  },
};
